module.exports = __webpack_public_path__ + "static/app-store-iphone.f192039a.png";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/badges/app-store-iphone.png
// module id = 1206
// module chunks = 0 1 2 3